import { notification } from 'antd'

export const identityMissing = () =>
  notification.error({
    message: 'Erreur',
    description: 'Vous semblez ne pas être connecté'
  })

export const genericError = () =>
  notification.error({
    description: "Une erreur s'est produite, merci de bien vouloir réessayer",
    message: 'Erreur'
  })



// WEBPACK FOOTER //
// ./src/utils/notifications.utils.ts